import { cn } from '@core/utils';

import { CustomLink } from '@/app/_components/CustomLink';
import { Image } from '@/components/client';
import { ROUTES, STORAGE_KEY } from '@/constants';
import { buildDetailSlug } from '@/utils/detailSlug';

interface RecommendHometownNewsVerticalCardProps {
  className?: string;
  idIdx: string;
  name: string;
  publishedAt: string;
  thumbnail: string;
}

export const RecommendHometownNewsVerticalCard = ({
  className,
  idIdx,
  name,
  publishedAt,
  thumbnail,
}: RecommendHometownNewsVerticalCardProps) => {
  const routePathname = ROUTES.HOMETOWN_NEWS_DETAIL.pathname({
    idIdx: buildDetailSlug(idIdx, name),
  });

  const handleClick = () => {
    sessionStorage.setItem(
      STORAGE_KEY.HOMETOWN_NEWS_DETAIL_BOTTOM_DRAWER_PATH,
      routePathname,
    );
  };

  return (
    <CustomLink
      className={cn('flex h-244 w-161 flex-col gap-10', className)}
      href={routePathname}
      onClick={handleClick}
    >
      <Image
        alt={name}
        className="size-160 rounded-small border border-Gray-300 object-cover"
        height={160}
        src={thumbnail}
        width={160}
      />
      <section className="flex h-73 flex-col justify-between gap-6">
        <h4 className="line-clamp-2 text-ellipsis break-all font-500 text-Gray-900 typo-body3">
          {name}
        </h4>
        <p className="font-400 text-Gray-600 typo-caption1">{publishedAt}</p>
      </section>
    </CustomLink>
  );
};
